import DefaultLineChart from "examples/Charts/LineCharts/DefaultLineChart";
import colors from "assets/theme/base/colors";
import VerticalBarChart from "examples/Charts/BarCharts/VerticalBarChart";

export function getSalesSuperIntendenciaCompaniesLinealCharts(superIndenciaSalesData) {
  // param: superIndenciaSalesData list of: [    {
  //     "empresa": "ALIMENTOS BALANCEADOS AVIFORTE CIA. LTDA.",
  //     "venta1": 26339344.90,
  //     "venta2": 27030684.20,
  //     "venta3": 26711677.80,
  //     "totalsales": 80081706.90,
  //     "sector": "AVICULTURA / GANADERÍA"
  // }]
  let lineChartsLabels = [];
  const colorList = Object.keys(colors.gradients);
  var verticalChartlabels = [];
  var verticalChartData2019 = [];
  var verticalChartData2020 = [];
  var verticalChartData2021 = [];

  let _dataSet = [];
  superIndenciaSalesData.forEach((element) => {
    verticalChartlabels.push(element.empresa);
    lineChartsLabels.push(element.empresa);
    verticalChartData2019.push(element.venta1);
    verticalChartData2020.push(element.venta2);
    verticalChartData2021.push(element.venta3);
  });
  [2019, 2020, 2021].forEach((year, index) => {
    _dataSet.push({
      label: year,
      color: colorList[index],
      data: verticalChartlabels.map((companyName) => {
        const row = superIndenciaSalesData.filter((elem) => {
          return elem.empresa === companyName;
        });
        if (year === 2019) {
          return row[0].venta1;
        }
        if (year === 2020) {
          return row[0].venta2;
        }
        if (year === 2021) {
          return row[0].venta3;
        }
      }),
    });
  });
  let now = new Date();
  let anio3 = now.getFullYear();
  return (
    <div>
      <DefaultLineChart
        icon={{ color: "info", component: "leaderboard" }}
        title="Vista General"
        description="Todas las Empresas por Año"
        height="30rem"
        chart={{
          labels: lineChartsLabels,
          datasets: _dataSet,
        }}
      />
      <br></br>
      <VerticalBarChart
        icon={{ color: "info", component: "leaderboard" }}
        title={anio3 - 3}
        description="Ventas por Empresas"
        chart={{
          labels: verticalChartlabels,
          datasets: [
            {
              label: "Ventas" + (anio3 - 3) + "($)",
              color: "dark",
              data: verticalChartData2019,
            },
          ],
        }}
      />
      <br></br>
      <VerticalBarChart
        icon={{ color: "info", component: "leaderboard" }}
        title={anio3 - 2}
        description="Ventas por Empresas"
        chart={{
          labels: verticalChartlabels,
          datasets: [
            {
              label: "Ventas" + (anio3 - 2) + "($)",
              color: "success",
              data: verticalChartData2020,
            },
          ],
        }}
      />
      <br></br>
      <VerticalBarChart
        icon={{ color: "info", component: "leaderboard" }}
        title={anio3 - 1}
        description="Ventas por Empresas"
        chart={{
          labels: verticalChartlabels,
          datasets: [
            {
              label: "Ventas" + (anio3 - 1) + "($)",
              color: "info",
              data: verticalChartData2021,
            },
          ],
        }}
      />
    </div>
  );
}
